import * as React from 'react';
import styled from '@emotion/styled';
import { useHighlightHandlers } from '../../contexts/HighlightContext/Highlight';
import { Typography as MuiTypography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import { useTranslation } from 'next-i18next';
import { CustomButton } from '../CustomButton';
import { useAppContext } from '../../contexts/AppContext';

export interface CardContentProps {
  title?: string | undefined;
  description?: string | undefined;
  limit?: number | undefined;
  hideDescription?: boolean | undefined;
  className?: string;
}

const Typography = React.forwardRef<HTMLInputElement, any>((props, ref) =>
  useHighlightHandlers(MuiTypography, { forwardedRef: ref, ...props })
);

const CardContentStyled = styled(CardContent)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    textAlign: 'left',
    height: '100%',
    border: theme.theme_component_card_content_border || 'none',
    borderTop: 'none',
    pointerEvents: 'none',
    padding: 0,
    paddingBottom: '0 !important',
    paddingLeft: theme.spacing(1.5),
  },
  [theme.breakpoints.down('csm')]: {
    display: "flex",
    width: "100%",
    paddingTop: "0px"
  }
})) as typeof CardContent;

const CardContentInfo = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  '-webkit-line-clamp': '1',
  overflow: 'hidden',
  'text-overflow': 'ellipsis',
  '-webkit-box-orient': 'vertical',
  display: '-webkit-box',
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  width: '100%',
  display: 'inline-block',
  color: '#000',
  [theme.breakpoints.down('csm')]: {
    fontSize: "24px"
  },
  [theme.breakpoints.down('csm')]: {
    fontSize: "15px"
  }
}));

const Description = styled(Typography)(({ theme }) => ({
  height: 'auto',
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  overflow: 'hidden',
  'text-overflow': 'ellipsis',
  '-webkit-box-orient': 'vertical',
  [theme.breakpoints.down('csm')]: {
    fontSize: "12px"
  }
}));

const ButtonStyled = styled(CustomButton)(({ theme }) => ({
  display: 'flex',
  justifyContent: "center",
  alignItems: "center",
  margin: 0,
  pointerEvents: 'auto',
  alignSelf: 'center',
  borderRadius: '46px',
  width: "107px",
  height: "40px",
  fontSize: "20px",
  [theme.breakpoints.down('cxs')]: {
    width: "85px",
    height: "31px",
    fontSize: "16px"
  }
}));


const getText = (val: string, limit: number) => {
  if (val !== '' && val !== null && val !== undefined && val?.length > limit) {
    return `${val.slice(0, limit - 3)}...`;
  }
  return val;
};

export const CollectionContentD = (props: any) => {
  const {
    description,
    title,
    limit,
    className,
    company,
    hideInfoSection,
    hideDeveloperName = false,
    hideDescription = true,
    hidePlayButton
  } = props;

  const { t } = useTranslation('card_content_e');
  const { useConfig } = useAppContext();
  const { componentOptions } = useConfig();
  

  return (
    <>
      {(title || description || company) && !hideInfoSection && (
        <CardContentStyled className={className}>
          <CardContentInfo>
            <CardTitle variant="caption" noWrap>
              {getText(title || '', limit || 35)}
            </CardTitle>
            {!hideDeveloperName && (
              <Description variant="body2" color="textPrimary">
                {company && getText(company, limit || 80)}
              </Description>
            )}
            {!hideDescription && (
              <Description variant="body2" color="textPrimary">
                {description && getText(description, limit || 80)}
              </Description>
            )}
          </CardContentInfo>
          {!hidePlayButton && (
            <ButtonStyled
              variant="contained"
              disableElevation
              disableRipple
              disableFocusRipple
              size="small"
            >
              {componentOptions.component_card_title_text || t('play_now', 'Play')}
            </ButtonStyled>
          )}
        </CardContentStyled>
      )}
    </>
  );
};
